import { StoreThunkAction } from 'store/state'
import { Observable } from 'rxjs'
import { V1, CopyPostsData } from './net'
import { tap } from 'rxjs/operators'
import { HS_EVENT_POST_COPIED, trackHubspotEvent } from 'services/tracking/hubspot'

export function copyPosts(data: CopyPostsData): StoreThunkAction<Observable<any>> {
  return (dispatch) => {
    return dispatch(V1.copyPosts(data)).pipe(tap(() => {
      dispatch(trackHubspotEvent(HS_EVENT_POST_COPIED))
    }))
  }
}
